/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { ContextMenu } from "components/contextMenu/ContextMenu";
import {
  getContextMenuYPosition,
  getContextMenuXPosition,
  getContextMenuItems,
  getContextMenuTriggerType,
  getContextMenuTriggerPageIndex,
  getIsContextMenu,
  getContextMenuStyle,
  getTrapFocus
} from "selectors/contextMenuSelectors";
import { getPageZoomLevel } from "selectors/zoom";
import { getShouldHideContextMenu, isTouchSelectionPresent } from "dc-preview-utils/src/selectors/touchSelectors";
import { showHUD } from "selectors/hudSelectors";
import { getPositionInTouchDevices } from "utils/ContextMenuUtils";
import { getShouldUseModernViewer } from "selectors/appSelectors";

function mapStoreToProps(stores, ownProps) {
  return {
    menuItems: getContextMenuItems(stores).slice(),
    xPosition: getContextMenuXPosition(stores),
    yPosition: getContextMenuYPosition(stores),
    getShouldHideContextMenu: getShouldHideContextMenu(stores),
    isTouchSelectionPresent: isTouchSelectionPresent(stores),
    pageZoomLevel: getPageZoomLevel(stores, getContextMenuTriggerPageIndex(stores)),
    isContextMenu: getIsContextMenu(stores),
    contextMenuTrigger: getContextMenuTriggerType(stores),
    showHUD: showHUD(stores),
    contextMenuStyle: getContextMenuStyle(stores),
    getPositionInTouchDevices: (handle, menuItems) => getPositionInTouchDevices(stores, handle, menuItems),
    useModernViewer: getShouldUseModernViewer(stores),
    trapFocus: getTrapFocus(stores),
    setContextMenuHandle: contextMenuHandle => {
      stores.contextMenuStore.setContextMenuHandle(contextMenuHandle);
    }
  };
}

const ContextMenuContainer = inject(mapStoreToProps)(ContextMenu);

export { ContextMenuContainer };
